import Vue from "vue"
import router from "./routers"
import eventBus from "./events/event-bus"
// @ts-ignore
import store from "./store"

export function registerModule(app: Vue, module: any) {
  module({ app, store, router, eventBus })
}
